import React from 'react'

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon'

interface Props extends SvgIconProps {
  filled?: boolean
}

const pathOutlined =
  'M10.508 11.706c1.585.486 2.571 1.829 2.923 3.956a8 8 0 1 0-8.856.004c.379-2.115 1.371-3.454 ' +
  '2.943-3.95A4.001 4.001 0 0 1 9 4a4 4 0 0 1 1.508 7.706zm-5.005 4.491A7.968 7.968 0 0 0 9 17a' +
  '7.968 7.968 0 0 0 3.498-.803c-.307-2.522-1.433-3.697-3.466-3.697-2.035 0-3.183 1.177-3.529 3' +
  '.697zM9 18A9 9 0 1 1 9 0a9 9 0 0 1 0 18zm0-6.91a3.09 3.09 0 1 0 0-6.18 3.09 3.09 0 0 0 0 6.18z'

const pathFilled =
  'M4.44 16.76a9 9 0 1 1 9.09.019l.024-.153-.057-.497c-.353-3.027-1.871-4.629-4.465-4.629-2.592' +
  ' 0-4.13 1.598-4.528 4.622l-.065.496v.142zM9 11.09a3.09 3.09 0 1 0 0-6.18 3.09 3.09 0 0 0 0 6.18z'

const AvatarIcon: React.SFC<Props> = ({ filled, ...props }) => (
  <SvgIcon {...props} viewBox="-2 -2 22 22">
    <path d={filled ? pathFilled : pathOutlined} />
  </SvgIcon>
)

export default AvatarIcon
